<ul class="{{documents?.length < 2 ? 'is-single' : ''}}">
  @for (document of documents; track $index) {
    <li>
      <sd-document
        [brand]="brand"
        [data]="document"
        [titleLevel]="titleLevel"
        (downloadedDocument)="onDownloadDocument(document)"
      />
    </li>
  }
</ul>
<ng-container *ngTemplateOutlet="pushTemplate" />
